module.exports = __webpack_public_path__ + "img/nav_bg_empty.16298b3.png";